import { ReactElement } from 'react';

import { ComputeResourceType } from '@cast/shared-types';

import { ResourcesSimulationChart } from './_components/ResourcesSimulationChart';
import { SimulationContainer } from './_components/SimulationContainer';
import { useSimulationSettings } from './_components/useSimulationSettings';
import { vpaSettingsConstants } from '../../_constants/settingsConstants';
import { VerticalSettingsForm } from '../layout/VerticalSettingsForm';

const Simulations = () => {
  const { cpu, memory } = useSimulationSettings();

  return (
    <>
      <ResourcesSimulationChart
        testId="recommendation-percentile-simulation-cpu"
        type={ComputeResourceType.CPU}
        seed="scaling-policy-simulation-recommendationPercentile-cpu"
        percentile={cpu.percentile}
        overhead={cpu.overhead}
      />
      <ResourcesSimulationChart
        testId="recommendation-percentile-simulation-memory"
        type={ComputeResourceType.MEMORY}
        seed="scaling-policy-simulation-recommendationPercentile-memory"
        percentile={memory.percentile}
        overhead={memory.overhead}
      />
    </>
  );
};

type Props = {
  recommendationPercentileField: ReactElement;
};
export const RecommendationPercentileSettingsContainer = ({
  recommendationPercentileField,
}: Props) => {
  const { title, description, docsLinkKey, simulation } =
    vpaSettingsConstants.recommendationPercentile;

  return (
    <VerticalSettingsForm
      title={title}
      description={description}
      docsLinkKey={docsLinkKey}
      bottomContent={
        <SimulationContainer description={simulation.description}>
          <Simulations />
        </SimulationContainer>
      }
    >
      {recommendationPercentileField}
    </VerticalSettingsForm>
  );
};
